import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
import mattChocoTilsRoom1 from '../../assets/matt-choco-tils-room-1.jpg';
import WallModel from '../../assets/wall/WallModel.jpg';
import WallModel1 from '../../assets/wall/WallModel1.jpg';
import WallModel2 from '../../assets/wall/WallModel2.jpg';
import WallModel3 from '../../assets/wall/WallModel3.jpg';
import WallModel4 from '../../assets/wall/WallModel4.jpg';
import WallModel5 from '../../assets/wall/WallModel5.jpg';
import WallModel6 from '../../assets/wall/WallModel6.jpg';
import WallModel7 from '../../assets/wall/WallModel7.jpg';
import Wall from '../../assets/wall/Wall.jpg';
import Wall1 from '../../assets/wall/Wall1.jpg';
import Wall2 from '../../assets/wall/Wall2.jpg';
import Wall3 from '../../assets/wall/Wall3.jpg';
import Wall4 from '../../assets/wall/Wall4.jpg';
import Wall5 from '../../assets/wall/Wall5.jpg';
import Wall6 from '../../assets/wall/Wall6.jpg';
import Wall7 from '../../assets/wall/Wall7.jpg';
import CarvingModel from '../../assets/wall/CarvingModel.jpg';
import CarvingModel1 from '../../assets/wall/CarvingModel1.jpg';
import CarvingModel2 from '../../assets/wall/CarvingModel2.jpg';
import CarvingModel3 from '../../assets/wall/CarvingModel3.jpg';
import CarvingModel4 from '../../assets/wall/CarvingModel4.jpg';
import CarvingModel5 from '../../assets/wall/CarvingModel5.jpg';
import CarvingModel6 from '../../assets/wall/CarvingModel6.jpg';
import CarvingModel7 from '../../assets/wall/CarvingModel7.jpg';
import Carving from '../../assets/wall/Carving.jpg';
import Carving1 from '../../assets/wall/Carving1.jpg';
import Carving2 from '../../assets/wall/Carving2.jpg';
import Carving3 from '../../assets/wall/Carving3.jpg';
import Carving4 from '../../assets/wall/Carving4.jpg';
import Carving5 from '../../assets/wall/Carving5.jpg';
import Carving6 from '../../assets/wall/Carving6.jpg';
import Carving7 from '../../assets/wall/Carving7.jpg';
import GlossyModel from '../../assets/wall/GlossyModel.jpg';
import GlossyModel1 from '../../assets/wall/GlossyModel1.jpg';
import GlossyModel2 from '../../assets/wall/GlossyModel2.jpg';
import GlossyModel3 from '../../assets/wall/GlossyModel3.jpg';
import GlossyModel4 from '../../assets/wall/GlossyModel4.jpg';
import GlossyModel5 from '../../assets/wall/GlossyModel5.jpg';
import GlossyModel6 from '../../assets/wall/GlossyModel6.jpg';
import GlossyModel7 from '../../assets/wall/GlossyModel7.jpg';
import Glossy from '../../assets/wall/Glossy.jpg';
import Glossy1 from '../../assets/wall/Glossy1.jpg';
import Glossy2 from '../../assets/wall/Glossy2.jpg';
import Glossy3 from '../../assets/wall/Glossy3.jpg';
import Glossy4 from '../../assets/wall/Glossy4.jpg';
import Glossy5 from '../../assets/wall/Glossy5.jpg';
import Glossy6 from '../../assets/wall/Glossy6.jpg';
import Glossy7 from '../../assets/wall/Glossy7.jpg';
import GlossyModel600 from '../../assets/wall/GlossyModel600.jpg';
import GlossyModel6001 from '../../assets/wall/GlossyModel6001.jpg';
import GlossyModel6002 from '../../assets/wall/GlossyModel6002.jpg';
import GlossyModel6003 from '../../assets/wall/GlossyModel6003.jpg';
import GlossyModel6004 from '../../assets/wall/GlossyModel6004.jpg';
import GlossyModel6005 from '../../assets/wall/GlossyModel6005.jpg';
import GlossyModel6006 from '../../assets/wall/GlossyModel6006.jpg';
import GlossyModel6007 from '../../assets/wall/GlossyModel6007.jpg';
import Glossy600 from '../../assets/wall/Glossy600.jpg';
import Glossy6001 from '../../assets/wall/Glossy6001.jpg';
import Glossy6002 from '../../assets/wall/Glossy6002.jpg';
import Glossy6003 from '../../assets/wall/Glossy6003.jpg';
import Glossy6004 from '../../assets/wall/Glossy6004.jpg';
import Glossy6005 from '../../assets/wall/Glossy6005.jpg';
import Glossy6006 from '../../assets/wall/Glossy6006.jpg';
import Glossy6007 from '../../assets/wall/Glossy6007.jpg';

const Matt = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // State for filters
  const [selectedSize, setSelectedSize] = useState("300x450 mm");
  const [selectedFinish, setSelectedFinish] = useState("GLOSSY");

  // Available Finishes - will be filtered based on size
  const allFinishes = ['CARVING', 'GLOSSY'];

  // Function to open modal with selected image
  const openModal = (image, title, viewMode = 'single', roomScene = null) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title, viewMode, roomScene });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // Carving Images Collection (300x450)
  const carving450Images = [
    { src: Wall, title: 'COSTONE GREY', roomScene: WallModel },
    { src: Wall1, title: 'DELLIN BIANCO', roomScene: WallModel1 },
    { src: Wall2, title: 'DELLIN BROWN', roomScene: WallModel2 },
    { src: Wall3, title: 'DELLIN CREMA', roomScene: WallModel3 },
    { src: Wall4, title: 'DELLIN GREY', roomScene: WallModel4 },
    { src: Wall5, title: 'DYWYNE BIANCO', roomScene: WallModel5 },
    { src: Wall6, title: 'DYWYNE CREMA', roomScene: WallModel6 },
    { src: Wall7, title: 'DYWYNE GREY', roomScene: WallModel7 },
  ];

  // Carving Images Collection (300x600)
  const carving600Images = [
    { src: Carving, title: 'DYWYNE ROSATA', roomScene: CarvingModel },
    { src: Carving1, title: 'EMILIA BROWN', roomScene: CarvingModel1 },
    { src: Carving2, title: 'EMILIA CREMA', roomScene: CarvingModel2 },
    { src: Carving3, title: 'EMILIA GREY', roomScene: CarvingModel3 },
    { src: Carving4, title: 'EMILIA WHITE', roomScene: CarvingModel4 },
    { src: Carving5, title: 'FOSSIL BIANCO', roomScene: CarvingModel5 },
    { src: Carving6, title: 'FOSSIL GREY', roomScene: CarvingModel6 },
    { src: Carving7, title: 'GOA AMBER', roomScene: CarvingModel7 },
  ];

  // Glossy Images Collection (300x450)
  const glossy450Images = [
    { src: Glossy, title: 'ARMANI BASE', roomScene: GlossyModel },
    { src: Glossy1, title: 'ARMANI BROWN', roomScene: GlossyModel1 },
    { src: Glossy2, title: 'ARMANI CREMA', roomScene: GlossyModel2 },
    { src: Glossy3, title: 'ARMANI GRAY', roomScene: GlossyModel3 },
    { src: Glossy4, title: 'ARMANI SANDY', roomScene: GlossyModel4 },
    { src: Glossy5, title: 'ARMANI WHITE', roomScene: GlossyModel5 },
    { src: Glossy6, title: 'ASTARDA BEIGE', roomScene: GlossyModel6 },
    { src: Glossy7, title: 'ASTARDA BIANCO', roomScene: GlossyModel7 },
  ];

  // Glossy Images Collection (300x600)
  const glossy600Images = [
    { src: Glossy600, title: 'ASTARDA BLUE', roomScene: GlossyModel600 },
    { src: Glossy6001, title: 'ASTARDA CREMA', roomScene: GlossyModel6001 },
    { src: Glossy6002, title: 'ASTARDA GRAY', roomScene: GlossyModel6002 },
    { src: Glossy6003, title: 'ASTARDA NERO', roomScene: GlossyModel6003 },
    { src: Glossy6004, title: 'ASTILIO BROWN', roomScene: GlossyModel6004 },
    { src: Glossy6005, title: 'ASTILIO CREMA', roomScene: GlossyModel6005 },
    { src: Glossy6006, title: 'ASTILIO GREY', roomScene: GlossyModel6006 },
    { src: Glossy6007, title: 'ASTILIO WHITE', roomScene: GlossyModel6007 },
  ];

  const mattCategory = {
    fullName: "Wall Finish Tiles",
    description:
      "Premium  finish tiles offering a non-reflective, anti-slip surface with exceptional durability and style.",
    features: ["Water Absorption < 0.5%", "Anti-Slip Surface", "Stain Resistant", "Low Maintenance"],
  };

  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${mattChocoTilsRoom1})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Wall Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {mattCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Wall Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {mattCategory.description} Our wall tiles combine advanced technology with a non-slip, textured surface to create safe and stylish spaces.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {mattCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* NEW FILTER SECTION */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-1">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 md:p-12 shadow-xl border border-gray-100">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">

              {/* Size Selection */}
              <div className="lg:w-1/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Size</h3>
                <div className="flex flex-col gap-4">
                  {["300x450 mm", "300x600 mm"].map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(selectedSize === size ? null : size)}
                      className={`
                        w-full py-4 px-6 rounded-xl text-lg font-bold transition-all duration-300 border
                        ${selectedSize === size
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {size.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Vertical Divider (Visible on Large Screens) */}
              <div className="hidden lg:block w-px bg-gray-200 my-2"></div>

              {/* Horizontal Divider (Visible on Small Screens) */}
              <div className="block lg:hidden h-px w-full bg-gray-200"></div>

              {/* Finish Selection */}
              <div className="lg:w-2/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Finish</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
                  {allFinishes
                    .filter(finish => {
                      if (selectedSize === "300x450 mm") {
                        return ['CARVING', 'GLOSSY'].includes(finish);
                      } else if (selectedSize === "300x600 mm") {
                        return ['CARVING', 'GLOSSY'].includes(finish);
                      }
                      return true;
                    })
                    .map((finish) => (
                      <button
                        key={finish}
                        onClick={() => setSelectedFinish(selectedFinish === finish ? null : finish)}
                        className={`
                        py-3 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 h-16 sm:h-20 flex items-center justify-center text-center border
                        ${selectedFinish === finish
                            ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                            : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                      >
                        {finish}
                      </button>
                    ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Carving Collection Grid - 300x450 */}
      {selectedFinish === 'CARVING' && selectedSize === "300x450 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Carving Series <span className="text-orange-600">300x450 mm</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Experience the depth and texture of our premium Carving finish tiles in 300x450 mm.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {carving450Images.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 300x450 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Carving Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Carving Collection Grid - 300x600 */}
      {selectedFinish === 'CARVING' && selectedSize === "300x600 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Carving Series <span className="text-orange-600">300x600 mm</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant Carving finish in our 300x600 mm collection.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {carving600Images.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 300x600 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Carving Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Glossy Collection Grid - only for 300x450 */}
      {selectedFinish === 'GLOSSY' && selectedSize === "300x450 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Glossy Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Glossy finish wall tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {glossy450Images.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 300x450 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Glossy Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Glossy Collection Grid - only for 300x600 */}
      {selectedFinish === 'GLOSSY' && selectedSize === "300x600 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Glossy Series <span className="text-orange-600">300x600 mm</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant Glossy finish in our 300x600 mm collection.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {glossy600Images.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 300x600 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Glossy Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Available Sizes Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Available <span className="text-orange-600">Sizes</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto">
              {["300x450 mm", "300x600 mm"].map((size, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-100 to-orange-200 text-orange-800 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl text-center shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1"
                >
                  <div className="text-lg sm:text-xl md:text-2xl mb-1 sm:mb-2">📏</div>
                  <div className="text-sm sm:text-base md:text-lg">{size}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon: "💧", title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon: "💪", title: "Breaking Strength", desc: "Minimum 1800N as per IS 15622" },
              { icon: "🛡️", title: "Anti-Slip Surface", desc: "R10 rating for enhanced safety" },
            ].map((spec, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Space Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect wall finish tiles for your project. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className={`relative w-full mx-auto outline-none ${selectedImage.viewMode === 'detail' ? 'max-w-7xl' : 'max-w-5xl'}`}>

            {selectedImage.viewMode === 'detail' ? (
              // Detailed Product Modal
              <div className="bg-white rounded-xl overflow-hidden shadow-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="bg-orange-600 p-4 sm:p-6 text-center relative">
                  <h2 className="text-white text-xl sm:text-3xl font-bold uppercase tracking-wider">{selectedImage.title}</h2>
                  <button
                    onClick={closeModal}
                    className="absolute top-1/2 -translate-y-1/2 right-4 sm:right-6 text-white hover:text-orange-200 transition-colors text-2xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <div className="flex flex-col lg:flex-row">
                  {/* Left: Room Scene */}
                  <div className="lg:w-1/2 p-6 bg-gray-50 flex items-center justify-center">
                    <img
                      src={selectedImage.roomScene || selectedImage.src}
                      alt="Room Scene"
                      className="w-full h-full rounded-lg shadow-md object-cover max-h-[500px]"
                    />
                  </div>

                  {/* Right: Faces & Info */}
                  <div className="lg:w-1/2 p-6 flex flex-col">
                    {/* Faces Grid */}
                    <div className="grid grid-cols-4 gap-3 mb-8">
                      {[1, 2, 3, 4].map((_, i) => (
                        <div key={i} className="aspect-[9/16] rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                          <img src={selectedImage.src} alt={`Face ${i + 1}`} className="w-full h-full object-cover" />
                        </div>
                      ))}
                    </div>

                    {/* Product Info */}
                    <div>
                      <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                        Elegant wall texture with subtle design for luxurious spaces.
                        Perfect for both residential and commercial applications.
                      </p>

                      <div className="flex flex-wrap gap-3 mb-6">
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Size: {selectedSize}
                        </span>
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Finish: {selectedFinish ? selectedFinish : 'Matt'}
                        </span>
                      </div>

                      <div className="space-y-2">
                        {['High Strength', 'Water Resistant', 'Stain Resistant', 'Easy Maintenance'].map((feat, i) => (
                          <div key={i} className="flex items-center text-gray-700">
                            <span className="text-orange-600 mr-2">✓</span>
                            {feat}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Simple Zoom Modal
              <div className="relative flex flex-col items-center justify-center">
                {isImageLoading && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 sm:w-14 lg:w-16 h-12 sm:h-14 lg:h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  src={selectedImage.src}
                  alt={`Zoomed view of ${selectedImage.title}`}
                  className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl"
                  onLoad={() => setIsImageLoading(false)}
                />
                <button
                  onClick={closeModal}
                  className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white text-black rounded-full p-2 sm:p-3 hover:bg-gray-200 transition-all duration-300 text-base sm:text-lg lg:text-xl font-bold shadow-lg"
                >
                  ✕
                </button>
                {selectedImage && !isImageLoading && (
                  <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-4 bg-black/70 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg">
                    <h3 className="text-sm sm:text-base md:text-lg font-bold">{selectedImage.title}</h3>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div >
  );
};

export default Matt;